export const restrictedWords = ["Invoice", "Child"];